let sections = document.querySelectorAll("[data-section-type]");
let url = new URL(location.href);
let model_type = url.searchParams.get("type");
let brand_name = url.searchParams.get("brand");

function hide_section(type, brand, sectionsArr) {
  sectionsArr.forEach((section) => {
    let brand_compare = section.dataset.brandName;
    let modelType_compare = section.dataset.sectionType;

    modelType_compare = modelType_compare.toLowerCase();
    type = type.toLowerCase();
    brand_compare = brand_compare.toLowerCase();
    brand = brand.toLowerCase();
    if (modelType_compare == type && brand_compare == brand) {
      section.style.display = "block";
    } else {
      section.style.display = "none";
    }
  });
}
hide_section(model_type, brand_name, sections);
